import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  OPEN_ADD_A_CREDIT_CARD,
  SET_CARD_KNOX_SUBMITTING
} from "@constants/actionTypes";

import styled from "@emotion/styled";
import classNames from "classnames";
import loadable from "@loadable/component";
const MessageContainer = loadable(() =>
  import(
    /* webpackChunkName: "MessageContainer" */ "../../../components/MessageContainer"
  )
);
import { postNewPaymentMethod } from "@actions/paymentMethods";
import { defaultAction } from "@actions/defaultAction";
import { reduxForm, getFormValues } from "redux-form";
import CardKnox from "@components/forms/CardKnox";

const PopUpContainer = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  overflow-y: scroll;
  z-index: 109;
  background-color: rgba(31, 32, 33, 0.8);
  padding-bottom: 50px;
`;

const Container = styled.div`
  width: 579px;
  height: auto;
  border-radius: 30px;
  background-color: #f8f8f8;
  margin: 0 auto;
  margin-top: 100px;

  @media (max-height: 900px) {
    margin-top: 63px;
  }
  @media (max-height: 815px) {
    margin-top: 45px;
  }
  @media (max-height: 735px) {
    margin-top: 15px;
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`;

const CloseDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  color: #9b9b9b;
  align-self: flex-start;
  padding-top: 20px;
  padding-right: 26px;
  padding-left: 26px;

  @media (max-height: 600px) {
    padding-right: 20px;
    padding-top: 20px;
  }

  @media (max-width: 450px) {
    padding-right: 20px;
  }
`;

const CloseDivImage = styled.img`
  width: 17px;
`;

const CloseSpan = styled.span`
  cursor: pointer;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  margin: 0 auto;
  max-width: 464px;
  padding-bottom: 38px;
  text-align: left;
  margin-top: -10px;

  @media (max-height: 815px) {
    margin-top: -12px;
  }

  @media (max-width: 600px) {
    width: 90%;
  }
  @media (max-width: 415px) {
    margin-top: 10px;
  }
`;

const Header = styled.div`
  font-size: 30px;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
  color: #1f2021;
  margin: 0 auto;
  margin-bottom: 20px;

  @media (max-height: 815px) {
    font-size: 28px;
  }

  @media (max-width: 475px) {
    font-size: 24px;
  }
  @media (max-width: 360px) {
    font-size: 25px;
    max-width: 217px;
  }
`;

const AddACreditCard = ({
  hideModal,
  addACreditCard,
  invalid,
  postNewPaymentMethod,
  formValues,
  customerInfo,
  setCardKnoxSubmission
}) => {
  const [ccServerError, changeCcserverError] = useState("");
  const [cardKnoxSubmitting, changeCardKnoxSubmitting] = useState(false);
  const [submitText, setSubmitText] = useState("Submit");
  const [submitButton, setSubmitButton] = useState("ORANGE_BUTTON");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => (document.body.style.overflow = "initial");
  }, [addACreditCard]);

  const closeModal = () => {
    hideModal();
  };

  const handleSaveAndContinue = async (cardNumToken, cvvNumToken) => {
    changeCardKnoxSubmitting(true);

    const postObject = {
      creditCardData: {
        creditCard: {
          numberToken: cardNumToken,
          cvvToken: cvvNumToken
        }
      },

      default: false,
      paymentMethod: "CREDITCARD",
      type: "buy"
    };
    const results = await postNewPaymentMethod(postObject, "addACreditCard");
    if (results?.data?.data) {
      changeCcserverError("");
      setSubmitText("Success");
      setSubmitButton("GREEN_BUTTON");
      changeCardKnoxSubmitting(false);

      setTimeout(() => {
        hideModal();
      }, 1000);
    } else if (results?.error) {
      let message = "";
      if (results.error.startsWith("Error adding credit card")) {
        message =
          "We were unable to add your credit card, please try another card.";
      } else if (results.error.toLowerCase().includes("instance")) {
        message = "Sorry something went wrong, please try again";
      } else {
        message = results.error;
      }
      changeCcserverError(message);
      changeCardKnoxSubmitting(false);
      setCardKnoxSubmission(false);
    }
  };

  return (
    <PopUpContainer className={classNames("animated", "fast", "fadeInUp")}>
      <Container onClick={e => e.stopPropagation()}>
        <CloseDiv className="mar-t-10">
          <CloseSpan onClick={closeModal}>
            <CloseDivImage
              src="https://cdn.cardcash.com/website/ui/elements/close.svg"
              aria-hidden="true"
              alt="close button"
            />
          </CloseSpan>
        </CloseDiv>
        <Content>
          <Header>New Credit Card</Header>

          <>
            {ccServerError && (
              <div>
                <MessageContainer
                  message={ccServerError}
                  classes={"credit-card-form-error-message"}
                />
              </div>
            )}
            <form>
              <CardKnox
                handleSaveAndContinue={handleSaveAndContinue}
                checkboxName={"creditCardInformation.saveAsDefault"}
                billingCheckboxName={
                  "creditCardInformation.creditBillingCheckbox"
                }
                invalid={invalid}
                cardKnoxSubmitting={cardKnoxSubmitting}
                changeCcserverError={changeCcserverError}
                ccServerError={ccServerError}
                setClassName={"account-add-credit-card-form"}
                billingValid={
                  formValues?.creditCardInformation?.creditBillingCheckbox
                }
                formData={formValues}
                buttonType={submitButton}
                submitText={submitText}
                missingInfo={
                  !customerInfo.firstname ||
                  !customerInfo.lastname ||
                  !customerInfo.street ||
                  !customerInfo.city ||
                  !customerInfo.state ||
                  !customerInfo.zip
                }
              />
            </form>
          </>
        </Content>
      </Container>
    </PopUpContainer>
  );
};

export default connect(
  state => ({
    initialValues: {
      creditBilling: {
        firstname: state.customerInfo.firstname,
        lastname: state.customerInfo.lastname,
        street: state.customerInfo.street,
        street2: state.customerInfo.street2,
        city: state.customerInfo.city,
        state: state.customerInfo.state,
        zip: state.customerInfo.zip
      },
      creditCardInformation: {
        saveAsDefault: false,
        creditBillingCheckbox:
          state.customerInfo.firstname &&
          state.customerInfo.lastname &&
          state.customerInfo.street &&
          state.customerInfo.city &&
          state.customerInfo.state &&
          state.customerInfo.zip &&
          state.customerInfo.phone
            ? true
            : false
      }
    },
    addACreditCard: state.popupsActions.addACreditCard,
    formValues: getFormValues("addACreditCard")(state),
    customerInfo: state.customerInfo
  }),
  dispatch => ({
    hideModal: () => dispatch(defaultAction(OPEN_ADD_A_CREDIT_CARD, false)),
    postNewPaymentMethod: (obj, formName) =>
      dispatch(postNewPaymentMethod(obj, formName)),
    setCardKnoxSubmission: bool =>
      dispatch(defaultAction(SET_CARD_KNOX_SUBMITTING, bool))
  })
)(
  reduxForm({
    form: "addACreditCard",
    enableReinitialize: true
  })(AddACreditCard)
);
